import { render, staticRenderFns } from "./ComplianceComponent.vue?vue&type=template&id=7271c7fa"
import script from "./ComplianceComponent.vue?vue&type=script&lang=js"
export * from "./ComplianceComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports